import { Marker } from 'react-google-maps'
import InfoBox from 'react-google-maps/lib/components/addons/InfoBox'
import { bool, func, shape } from 'prop-types'
import React from 'react'
import Card from './Card'

class VenueMarker extends React.Component {
  handleClick = () => {
    this.props.retainState()
    this.props.venueMarkerWasClicked(this.props.venue._id)
  }
  render() {
    return (
      <Marker
        icon={{
          scaledSize: new google.maps.Size(19, 27),
          url: '/themes/custom/venues/images/pin.svg',
        }}
        key={this.props.venue._id}
        onClick={this.handleClick}
        options={{
          optimized: false,
        }}
        position={{
          lat: this.props.venue.latitude,
          lng: this.props.venue.longitude,
        }}
      >
        {this.props.isOpen &&
          <InfoBox
            onCloseClick={this.handleClick}
            options={{
              alignBottom: true,
              closeBoxURL: '',
              enableEventPropagation: false,
              pixelOffset: new google.maps.Size(16, 12),
            }}

          >
            <Card venue={this.props.venue} />
          </InfoBox>
        }
      </Marker>
    )
  }
}
VenueMarker.propTypes = {
  isOpen: bool.isRequired,
  retainState: func.isRequired,
  venue: shape({}).isRequired,
  venueMarkerWasClicked: func.isRequired,
}

export default VenueMarker
